export default function ChooseFigureButttonPressedController(view, model) {
  return ({
    index
  }) => {
    if (model.done) {
      model.deferred.resolve();
      return;
    }
    console.log(index);
    switch (index) {
      case 14:
        // left
        view.selectPrevFigure();
        break;
      case 15:
        // right
        view.selectNextFigure();
        break;
      case 0:
      case 1:
      case 2:
      case 3:
        view.submit();
        break;
    }
  };
}